export default function Subtitle ({ subtitle, paragraph }) {
    return (
        <>
            <section id="subtitle" className="overflow-hidden bg-grays py-12">
                <div className="mx-auto max-w-7xl px-6 lg:px-8">
                    <div className="mx-auto grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 sm:gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-3">
                        <div className="col-span-3 md:-ml-4 lg:-ml-0">           
                            <div className="lg:max-w-5xl">
                                <h2 className="m-auto 2xl:text-5xl xl:text-4xl lg:text-3xl text-2xl pt-6">
                                    {subtitle}
                                </h2>
                                <p className="m-auto pt-6 text-lg">
                                    {paragraph}
                                </p>
                            </div>
                        </div>                    
                    </div>
                </div>
           </section>
        </>
    )
}